export const isDevelopment = process.env.NODE_ENV === 'development'

export const isProduction = process.env.NODE_ENV === 'production'

export const isTest = process.env.NODE_ENV === 'test'

export const isWindows = () =>
  window.navigator.userAgent.search(/Windows/i) !== -1
